// Base values for meta tags
// So they can be added as suffixes on different pages
// Via <svelte:head>

export const siteBaseUrl = 'https://jackbellinger.github.io/blog';

export const keywords = ['Svelte', 'Axum', 'tech', 'Blog', 'Jack', 'Bellinger'];

export const description = 'The blog & portfolio of Jack Bellinger';

export const title = 'Jack Bellinger';

export const image = `@assets/images/blog_preview.png`;
